import { Loader } from "@common/handleErrorAndLoading/Loader";
import "./css/AbsoluteLoader.scss";

interface IParams {
    size?: number;
}

export const AbsoluteLoader = (props: IParams) => {
    const { size } = props;

    return (
        <div className="loader-container">
            <Loader size={size} />
        </div>
    );
};
